// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2qwBy","clinicsSelect":"TableHeading_clinicsSelect__1LN4F"};